import React, {useState} from "react";
import {Outlet, useNavigate} from "react-router-dom";
import TopMenu from "./TopMenu";
import Footer from "./components/Footer";
import LanguageSetter from "./LanguageSetter";

const Application = () => {
    const [activeMenu, setActiveMenu] = useState("homepage");
    const navigate = useNavigate();

    const handleMenuChange = (menuKey) => {
        setActiveMenu(menuKey);
        navigate(`/${menuKey}`);
    };

    return (
        <>
            <LanguageSetter/>
            <div className={"d-flex flex-column background-FAFAFB"}>
                <TopMenu setActiveMenu={handleMenuChange}/>
                <Outlet/>
                <Footer></Footer>

            </div>
        </>
    );
};

export default Application;
